(function () {
  var TRIGGER_PREFIX = 'wasui-motion-';
  var TARGET_SELECTOR = '[data-wasui-animate-item], [data-wasui-animate-card], [data-wasui-animate-image]';
  var GROUP_SELECTOR = '[data-wasui-animate-group]';
  var refreshTimer = null;
  var matchMediaContext = null;
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function canAnimate() {
    return !reducedMotionQuery.matches && typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
  }

  function toArray(root, selector) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function unique(items) {
    return items.filter(function (item, index) {
      return item && items.indexOf(item) === index;
    });
  }

  function matches(element, selector) {
    return element && element.matches && element.matches(selector);
  }

  function nextId(type) {
    return TRIGGER_PREFIX + type + '-' + Math.random().toString(36).slice(2);
  }

  function releasePrehide() {
    document.documentElement.classList.remove('wasui-motion-pending');
    document.documentElement.classList.add('wasui-motion-ready');
  }

  function normalizeMotionTargets(root) {
    toArray(root || document, TARGET_SELECTOR).forEach(function (target) {
      target.style.removeProperty('opacity');
      target.style.removeProperty('visibility');
      target.style.removeProperty('transform');
    });
  }

  function clearMotion() {
    if (refreshTimer) {
      window.clearTimeout(refreshTimer);
      refreshTimer = null;
    }

    if (matchMediaContext) {
      matchMediaContext.revert();
      matchMediaContext = null;
    }

    normalizeMotionTargets(document);

    if (typeof window.ScrollTrigger !== 'undefined') {
      window.ScrollTrigger.getAll().forEach(function (trigger) {
        if (trigger.vars && trigger.vars.id && trigger.vars.id.indexOf(TRIGGER_PREFIX) === 0) {
          trigger.kill();
        }
      });
    }
  }

  function getGroupTargets(group) {
    var targets = [];

    if (matches(group, TARGET_SELECTOR)) {
      targets.push(group);
    }

    targets = targets.concat(toArray(group, TARGET_SELECTOR).filter(function (target) {
      return target.closest(GROUP_SELECTOR) === group;
    }));

    return unique(targets);
  }

  function resolveConfig(baseConfig, trigger, targets) {
    var hasImage = targets.some(function (target) {
      return matches(target, '[data-wasui-animate-image]');
    });
    var hasCard = targets.some(function (target) {
      return matches(target, '[data-wasui-animate-card]');
    });
    var targetCount = targets.length;

    return {
      y: hasImage ? baseConfig.imageY : baseConfig.y,
      duration: hasCard ? baseConfig.duration * 0.92 : baseConfig.duration,
      stagger: targetCount > 1 ? baseConfig.stagger : 0,
      start: hasImage ? baseConfig.imageStart : baseConfig.start,
      delay: Number(trigger.dataset.wasuiAnimateDelay || 0)
    };
  }

  function reveal(elements, trigger, config) {
    var targets = unique(elements).filter(function (element) {
      return element && !element.hasAttribute('hidden') && element.dataset.wasuiMotionRevealed !== 'true';
    });

    if (!targets.length || !trigger) return;

    window.gsap.set(targets, {
      autoAlpha: 0,
      y: config.y
    });

    window.gsap.fromTo(
      targets,
      {
        autoAlpha: 0,
        y: config.y
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: config.duration,
        delay: config.delay || 0,
        stagger: config.stagger || 0,
        ease: 'power3.out',
        clearProps: 'opacity,visibility,transform',
        immediateRender: false,
        onComplete: function () {
          targets.forEach(function (target) {
            target.dataset.wasuiMotionRevealed = 'true';
          });
        },
        scrollTrigger: {
          id: nextId('reveal'),
          trigger: trigger,
          start: config.start,
          once: true,
          invalidateOnRefresh: true
        }
      }
    );
  }

  function setupGroupedReveals(config) {
    var processedTargets = [];

    toArray(document, GROUP_SELECTOR).forEach(function (group) {
      var targets = getGroupTargets(group);

      if (!targets.length) return;

      processedTargets = processedTargets.concat(targets);
      reveal(targets, group, resolveConfig(config, group, targets));
    });

    toArray(document, TARGET_SELECTOR).forEach(function (target) {
      if (processedTargets.indexOf(target) !== -1) return;
      reveal([target], target, resolveConfig(config, target, [target]));
    });
  }

  function parallax(elements, config) {
    unique(elements).forEach(function (element) {
      var trigger = element.closest('[data-wasui-animate-section], [data-wasui-b2b-section]') || element;

      window.gsap.fromTo(
        element,
        { yPercent: config.from },
        {
          yPercent: config.to,
          ease: 'none',
          scrollTrigger: {
            id: nextId('parallax'),
            trigger: trigger,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.65,
            invalidateOnRefresh: true
          }
        }
      );
    });
  }

  function setupParallax() {
    parallax(toArray(document, [
      '.wasui-passport__image-column img',
      '.wasui-passport__bottom img',
      '[data-wasui-b2b-page] .wasui-b2b-for-business-passport__image img'
    ].join(',')), {
      from: -3,
      to: 3
    });
  }

  function initMotion() {
    clearMotion();

    if (!canAnimate()) {
      normalizeMotionTargets(document);
      releasePrehide();
      return;
    }

    window.gsap.registerPlugin(window.ScrollTrigger);
    matchMediaContext = window.gsap.matchMedia();

    matchMediaContext.add('(min-width: 990px)', function () {
      window.gsap.registerPlugin(window.ScrollTrigger);
      normalizeMotionTargets(document);

      setupGroupedReveals({
        y: 40,
        imageY: 44,
        duration: 0.88,
        stagger: 0.08,
        start: 'top 84%',
        imageStart: 'top 86%'
      });

      setupParallax();

      return function () {
        normalizeMotionTargets(document);
      };
    });

    matchMediaContext.add('(max-width: 989px)', function () {
      window.gsap.registerPlugin(window.ScrollTrigger);
      normalizeMotionTargets(document);

      setupGroupedReveals({
        y: 12,
        imageY: 14,
        duration: 0.5,
        stagger: 0.03,
        start: 'top 92%',
        imageStart: 'top 88%'
      });

      return function () {
        normalizeMotionTargets(document);
      };
    });

    releasePrehide();

    refreshTimer = window.setTimeout(function () {
      window.ScrollTrigger.refresh();
    }, 250);
  }

  function scheduleInit() {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    if (!reducedMotionQuery.matches) {
      document.documentElement.classList.add('wasui-motion-pending');
      document.documentElement.classList.remove('wasui-motion-ready');
    }
    refreshTimer = window.setTimeout(initMotion, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotion);
  } else {
    initMotion();
  }

  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('shopify:section:reorder', scheduleInit);
  document.addEventListener('shopify:section:unload', scheduleInit);

  if (reducedMotionQuery.addEventListener) {
    reducedMotionQuery.addEventListener('change', scheduleInit);
  } else if (reducedMotionQuery.addListener) {
    reducedMotionQuery.addListener(scheduleInit);
  }
})();
